import { useState } from 'react'

import type { LineData } from '@/app/[locale]/price/[slug]/_components/CoinLineChart/hooks/useCoinLineChartProps'
import { useStockContext } from '@/app/[locale]/price/stocks/[symbol]/_contexts/StockContext'

export function useTitle({ btcPricesVisible }: { btcPricesVisible: boolean }) {
  const [mousePointData, setMousePointData] = useState<LineData | undefined>(void 0)
  const { stock } = useStockContext()
  const stokcPrice = mousePointData?.currentCoinPrice ?? stock.usd_price
  // when mouse in, show mousePointData and don't display the price change
  // when mouse out, use the session-aware price change from stock context
  const stockPriceChange = mousePointData?.currentCoinPrice ? void 0 : stock.usd_price_change_24h
  const btcPrice = btcPricesVisible ? mousePointData?.btcCoinPrice : void 0
  const isMouseInChart = mousePointData !== undefined
  return {
    setMousePointData,
    isMouseInChart,
    stokcPrice,
    btcPrice,
    stockPriceChange,
  }
}
